import React, { useEffect, useState, Fragment } from "react";
import { Checkbox, Form, Input } from "antd";
import PhoneNumberInput from "../../../PhoneNumberInput/PhoneNumberInput";
import {
  validatePhoneNumber,
  countryOptions,
  getPhoneNumberAndCountryPrefix,
  addCountryPrefixNumber
} from "../../../../utils/phoneNumberConstants"; import { referencePerson } from "../../utils/constants";
import "./index.css";
import { Requeriment } from "../../utils/models";

const ReferenteDonaciones = (props: any) => {
  const nombre: string = "referente-de-donaciones-form";
  const requerimientos: Requeriment[] = [];
  const data: any = props.data;
  const tituloForm = "Referente de donaciones";
  const [form] = Form.useForm();
  const actualizarDatos = props.actualizarDatos;
  const setActiveTabName = props.setActiveTabName;
  useEffect(() => {
    setActiveTabName(nombre)
  }, [])

  const procesarDatos = (valores: any) => {
    return {
      ...valores,
      telefono: addCountryPrefixNumber(valores.countryTelefono, valores.telefono),
      numeroDeContacto: addCountryPrefixNumber(valores.countryNumeroDeContacto, valores.numeroDeContacto),
      recibir_soporte: receiveDonations
    }
  }

  const FW = props.fw;

  const countryTelefono = Form.useWatch("countryTelefono", form);
  const countryNumeroDeContacto = Form.useWatch("countryNumeroDeContacto", form);

  const [receiveDonations, setReceiveDonations] = useState<boolean>(
    data[nombre] ? data[nombre]["recibir_soporte"] : false
  );

  useEffect(
    () => {
      const formdata: any = {
        email: "",
        personaReferente: "",
        countryNumeroDeContacto: "",
        countryTelefono: "",
        numeroDeContacto: "",
        telefono: ""
      };

      if (data[nombre]) {
        formdata.email = data[nombre]["email"];
        formdata.personaReferente = data[nombre]["personaReferente"];
        formdata.countryTelefono = getPhoneNumberAndCountryPrefix(data[nombre]["telefono"], 0);
        formdata.telefono = getPhoneNumberAndCountryPrefix(data[nombre]["telefono"], 1);
        formdata.countryNumeroDeContacto = getPhoneNumberAndCountryPrefix(data[nombre]["numeroDeContacto"], 0);
        formdata.numeroDeContacto = getPhoneNumberAndCountryPrefix(data[nombre]["numeroDeContacto"], 1);      
      }

      if (!receiveDonations) {
        formdata.email = "";
        formdata.personaReferente = "";
        formdata.countryNumeroDeContacto = "";
        formdata.countryTelefono = "";
        formdata.numeroDeContacto = "";
        formdata.telefono = "";
        form.resetFields();
      }

      form.setFieldsValue({
        email: formdata.email,
        personaReferente: formdata.personaReferente,
        countryNumeroDeContacto: formdata.countryNumeroDeContacto,
        countryTelefono: formdata.countryTelefono,
        numeroDeContacto: formdata.numeroDeContacto,
        telefono: formdata.telefono
      })
    },
    [receiveDonations]
  );

  return (
    <FW
      nombre={nombre}
      tituloForm={tituloForm}
      data={data}
      form={form}
      actualizarDatos={actualizarDatos}
      procesarDatos={procesarDatos}
      requerimientos={requerimientos}
    >
      <Checkbox
        checked={receiveDonations}
        onChange={(e) => setReceiveDonations(e.target.checked)}
      >
        ¿Desean recibir donaciones?
      </Checkbox>
      <div className="caption">
        Ingresar los datos de la persona referente de donaciones
      </div>
      {props.modo === "edicion" ? (
        <Form.Item
          label="idReferente"
          name="idReferente"
          className="idField"
        >
          <Input disabled={!receiveDonations} placeholder="idReferente" />
        </Form.Item>
      ) : (
        ""
      )}
      <Form.Item
        name="personaReferente"
        label="Persona Referente"
        className={receiveDonations ? "obligatorio" : ""}
        rules={[
          {
            required: !!receiveDonations,
            message:
              "Por favor, ingresar el nombre de una persona referente.",
            whitespace: true,
          },
          { type: "string" },
          {
            max: 50,
            message:
              "El nombre de la persona referente no debe exceder los 50 caracteres",
          },
          {
            pattern: referencePerson,
            message: "Por favor, ingresar sólo letras",
          },
        ]}
      >
        <Input disabled={!receiveDonations} placeholder="Ingresar el nombre de la persona referente" />
      </Form.Item>

      <PhoneNumberInput
        label="Teléfono"
        form={form}
        validateCallback={(phoneNumber: string) =>
          validatePhoneNumber(phoneNumber, countryTelefono)
        }
        validateRequired={() => { return receiveDonations ? true : false }}
        formInfoName="telefono"
        countryInfoName="countryTelefono"
        options={countryOptions}
        isUpdated={receiveDonations}
        disabled={!receiveDonations}
      />

      <PhoneNumberInput
        label="Contacto de Whatsapp"
        form={form}
        validateCallback={(phoneNumber: string) =>
          validatePhoneNumber(phoneNumber, countryNumeroDeContacto)
        }
        validateRequired={() => { return receiveDonations ? true : false }}
        formInfoName="numeroDeContacto"
        countryInfoName="countryNumeroDeContacto"
        options={countryOptions}
        isUpdated={receiveDonations}
        disabled={!receiveDonations}
      />

      {props.modo === "edicion" ? (
        <Form.Item
          className="idReferente"
          name="idReferente"
          label="idReferente"
        >
          <Input disabled={!receiveDonations} type="number" placeholder="idReferente" />
        </Form.Item>
      ) : (
        ""
      )}

      <Form.Item
        name="email"
        label="E-mail"
        className={receiveDonations ? "obligatorio" : ""}
        rules={[
          {
            required: !!receiveDonations,
            message: "Por favor, ingresar email.",
          },
          {
            type: "email",
            message: "El email ingresado no es válido",
          },
          {
            max: 60,
            message: "El email no debe exceder los 60 caracteres",
          },
        ]}
      >
        <Input disabled={!receiveDonations} placeholder="Ingresar e-mail" />
      </Form.Item>
    </FW>
  );
};

export default ReferenteDonaciones;
